var PGALogo = "/home/circleci/app/src/assets/pga-logo.svg";

export { PGALogo as default };
